<!-- 
A little icon-only navigator for moving between screens of a levy collection.

This is purely a UI nicety as the sidebar offers the same functionality. Lynn wouldn't let me 
delete it as she uses it all the time.
-->
<template>
  <div class="hidden-md-and-down">
    <v-tabs 
      slider-color="primary" 
      color="#fafafa"
      right
    >
      <v-tab v-if="!sandbox" key="dashboard" :to="`/levy-collections/${levyCollectionId}/dashboard`" class="lil-tab dashboard-tab">
        <v-tooltip top open-delay="0" close-delay="0" transition="null">
          <v-icon slot="activator" color="grey darken-3">dashboard</v-icon>
          <span>Dashboard</span>
        </v-tooltip>
      </v-tab>
      <v-tab v-if="sandbox" key="sandbox" :to="`/levy-collections/${levyCollectionId}/sandbox`" class="lil-tab sandbox-tab">
        <v-tooltip top open-delay="0" close-delay="0" transition="null">
          <v-icon slot="activator" color="grey darken-3">move_to_inbox</v-icon>
          <span>Sandbox</span>
        </v-tooltip>
      </v-tab>
      <v-tab v-if="!sandbox" key="workflow" :to="`/levy-collections/${levyCollectionId}/workflow`" class="lil-tab workflow-tab">
        <v-tooltip top open-delay="0" close-delay="0" transition="null">
          <v-icon slot="activator" color="grey darken-3">playlist_add_check</v-icon>
          <span>Workflow</span>
        </v-tooltip>
      </v-tab>
      <v-tab key="providers" :to="`/levy-collections/${levyCollectionId}/providers`" class="lil-tab providers-tab">
        <v-tooltip top open-delay="0" close-delay="0" transition="null">
          <v-icon slot="activator" color="grey darken-3">school</v-icon>
          <span>Providers</span>
        </v-tooltip>
      </v-tab>
      <v-tab key="overrides" :to="`/levy-collections/${levyCollectionId}/overrides`" class="lil-tab overrides-tab">
        <v-tooltip top open-delay="0" close-delay="0" transition="null">
          <v-icon slot="activator" color="grey darken-3">change_history</v-icon>
          <span>Overrides</span>
        </v-tooltip>
      </v-tab>
      <v-tab v-if="!sandbox" key="notices" :to="`/levy-collections/${levyCollectionId}/notices`" class="lil-tab notices-tab">
        <v-tooltip top open-delay="0" close-delay="0" transition="null">
          <v-icon slot="activator" color="grey darken-3">email</v-icon>
          <span>Notices</span>
        </v-tooltip>
      </v-tab>
      <v-tab v-if="!sandbox" key="invoices" :to="`/levy-collections/${levyCollectionId}/invoices`" class="lil-tab invoices-tab">
        <v-tooltip top open-delay="0" close-delay="0" transition="null">
          <v-icon slot="activator" color="grey darken-3">attach_money</v-icon>
          <span>Invoices</span>
        </v-tooltip>
      </v-tab>
      <v-tab v-if="!sandbox" key="settings" :to="`/levy-collections/${levyCollectionId}/setup`" class="lil-tab settings-tab">
        <v-tooltip top open-delay="0" close-delay="0" transition="null">
          <v-icon slot="activator" color="grey darken-3">settings</v-icon>
          <span>Setup</span>
        </v-tooltip>
      </v-tab>
      <v-tab key="history" :to="`/levy-collections/${levyCollectionId}/history`" class="lil-tab history-tab">
        <v-tooltip top open-delay="0" close-delay="0" transition="null">
          <v-icon slot="activator" color="grey darken-3">history</v-icon>
          <span>History</span>
        </v-tooltip>
      </v-tab>
    </v-tabs>
  </div>
</template>

<script>
export default {
  props: {
    levyCollectionId: {
      type: Number,
      required: true
    },
    sandbox: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss">
.lil-tab {
  &:hover {
    background-color: #f0f0f0 !important;
  }
  .v-tabs__item {
    padding: 0px !important;
  }
  .v-icon {
    padding: 0px 12px !important;
    line-height: 48px;
  }
}
</style>